var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPinkLibraryIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 57,
    viewBox: "0 0 55 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.7218 3.17188H44.9271C44.2209 3.17188 43.6484 3.65047 43.6484 4.24091V7.321H55.0006V4.2408C55.0005 3.65047 54.428 3.17188 53.7218 3.17188V3.17188Z",
    fill: "#F26283"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6484 11.166H55.0006V48.6516H43.6484V11.166Z",
    fill: "#F26283"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6484 52.5078H55.0006V56.574H43.6484V52.5078Z",
    fill: "#F26283"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2281 10.6367H1.27869C0.572492 10.6367 0 11.1153 0 11.7058V15.7376H14.5068V11.7058C14.5068 11.1153 13.9343 10.6367 13.2281 10.6367V10.6367Z",
    fill: "#F26283"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 19.5957H14.5068V56.5744H0V19.5957Z",
    fill: "#F26283"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.125 47.6621H37.5948V56.5817H19.125V47.6621Z",
    fill: "#F26283"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.125 12.8203H37.5948V43.8023H19.125V12.8203Z",
    fill: "#F26283"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3162 0H20.4037C19.6975 0 19.125 0.478592 19.125 1.06903V8.96602H37.5948V1.06892C37.5948 0.478592 37.0224 0 36.3162 0V0Z",
    fill: "#F26283"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinkLibraryIcon);
export default __webpack_public_path__ + "static/media/pinkLibraryIcon.9019f47bf68fb01a1a8ddfff6d928b82.svg";
export { ForwardRef as ReactComponent };